import { Box, Stack } from "@mui/material";
import VSNTypography from "../../../shared/VSNTypography";
import {
  PurpalFlowerBullet,
  StarIcon,
  FrontLineLogo,
} from "../../../shared/icon";
import { ReactComponent as VasanaLogo } from "../../../assets/header/svg/vasana_logo.svg";
import { PhysicalOnePagerResultStyle } from "./PhysicalOnePagerResultStyle";
import VSNImage from "../../../shared/VSNImage";
import { cardDesign } from "./CPETDashboard/AssessmentConstant";
import useOTBStyle from "../../otb/OTBStyle";

export const PDFHeader = ({ title, header }) => {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="end"
      sx={{
        borderBottom: "1px solid #B29263",
      }}
      py={1}
      mb={1}
    >
      <Stack minWidth="400px">
        <VSNTypography
          fontSize={24}
          sx={{ fontWeight: 700 }}
          mb={0.5}
          color="#B29263"
        >
          {title ?? ""}
        </VSNTypography>
        <Stack>
          <Stack direction="row" justifyContent="space-between" width="100%">
            <VSNTypography fontSize={14} color="var(--black)" width="100%">
              <span
                style={{
                  fontWeight: 600,
                  marginRight: "4px",
                  color: "#B29263",
                }}
              >
                Name:
              </span>{" "}
              {header?.name ?? ""}
            </VSNTypography>
            {/* <VSNTypography fontSize={14} color="var(--black)" width="100%">
              <span
                style={{
                  fontWeight: 600,
                  marginRight: "4px",
                  color: "#B29263",
                }}
              >
                Dept:
              </span>{" "}
              {header?.department ?? header?.dept}
            </VSNTypography> */}
          </Stack>
          <Stack direction="row" justifyContent="space-between" width="100%">
            <VSNTypography
              fontSize={14}
              color="var(--black)"
              textAlign="left"
              width="100%"
            >
              <span
                style={{
                  fontWeight: 600,
                  marginRight: "4px",
                  color: "#B29263",
                }}
              >
                Dept:
              </span>{" "}
              {header?.department ?? header?.dept}
            </VSNTypography>
            {/* <VSNTypography
              fontSize={14}
              color="var(--black)"
              textAlign="left"
              width="100%"
            >
              <span
                style={{
                  fontWeight: 600,
                  marginRight: "4px",
                  color: "#B29263",
                }}
              >
                {" "}
                Dept:
              </span>
              Pflugerville FD
            </VSNTypography> */}
          </Stack>
        </Stack>
      </Stack>

      <FrontLineLogo />
    </Stack>
  );
};

export const PDFRecommendationSection = ({ data, staticData }) => {
  const classes = PhysicalOnePagerResultStyle();
  return (
    <Stack
      className={classes.assessmentReportCard}
      position="relative"
      overflow="hidden"
      pb="92px"
      sx={{
        background: "#FAF6F0 !important",
      }}
    >
      <VSNTypography
        variant="h3"
        component="h3"
        className={classes.mdHeadingprimary}
        mb={1}
        sx={{
          fontSize: "16px !important",
          backgroundColor: "pink !importnant",
          color: "#B29263 !important",
          "&:before": { background: "#B29263 !important" },
        }}
      >
        {data?.title ?? ""}
      </VSNTypography>
      <VSNTypography component="p" className={classes.desc}>
        {data?.description ?? ""}
      </VSNTypography>
      <Stack direction="row" flexWrap="wrap" mt={1.75}>
        {data?.recommendations?.map((item, ind) => {
          const { color } = cardDesign[ind % cardDesign.length];
          const { image } = staticData[ind % staticData.length];
          return (
            <Stack key={ind} sx={{ width: "50%", px: 1 }}>
              <Stack
                sx={{ p: 2, mb: 1 }}
                style={{ background: color }}
                flexDirection="column"
              >
                <Box width="fit-content" mx="auto">
                  <VSNImage
                    src={image ?? item?.image}
                    alt="cardImage"
                    height="110px"
                    width="auto"
                  />
                </Box>
                <VSNTypography
                  fontSize="16px"
                  fontWeight={700}
                  lineHeight="23px"
                  color="#86650A"
                  textAlign="center"
                >
                  {item?.title}
                </VSNTypography>
                <VSNTypography
                  fontSize="14px"
                  color="var(--gray)"
                  textAlign="left"
                >
                  {item?.description}
                </VSNTypography>
              </Stack>
            </Stack>
          );
        })}
      </Stack>
      <Box position="absolute" sx={{ bottom: "16px", right: "20px" }}>
        <VSNTypography sx={{ textAlign: "end", paddingBottom: "6px" }}>
          Powered by
        </VSNTypography>
        <VasanaLogo width="140px" height="31" />
      </Box>
    </Stack>
  );
};

export const PDFCommonFAQSection = ({ title, description, data = [] }) => {
  const classes = PhysicalOnePagerResultStyle();

  return (
    <Stack
      className={classes.assessmentReportCard}
      sx={{
        background: "#FAF6F0 !important",
      }}
    >
      <VSNTypography
        variant="h3"
        component="h3"
        className={classes.mdHeadingprimary}
        mb={1}
        sx={{
          fontSize: "16px !important",
          color: "#B29263 !important",
          "&:before": { background: "#B29263 !important" },
        }}
      >
        {title ?? ""}
      </VSNTypography>
      <VSNTypography component="p" className={classes.desc}>
        {description ?? ""}
      </VSNTypography>

      <Stack gap={1} pt={1}>
        {data?.map((el, index) => (
          <Stack direction="row" key={index}>
            <Box mr={2} mt={0.6}>
              <PurpalFlowerBullet height="14" width="14" />
            </Box>
            <VSNTypography
              sx={{
                fontSize: "14px !important",
                fontWeight: 500,
                color: "#0A0A0B",
                lineHeight: "24px",
              }}
            >
              <span style={{ color: "#86650A", fontWeight: 500 }}>
                {el?.question ?? ""}{" "}
              </span>
              <br />
              {el?.answer}
            </VSNTypography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export const PDFCommonSummarySection = ({ title, description, data = [] }) => {
  const classes = PhysicalOnePagerResultStyle();

  return (
    <Stack
      className={classes.assessmentReportCard}
      sx={{
        background: "#FAF6F0 !important",
      }}
    >
      <VSNTypography
        variant="h3"
        component="h3"
        className={classes.mdHeadingprimary}
        mb={1}
        sx={{
          fontSize: "16px !important",
          color: "#B29263 !important",
          "&:before": { background: "#B29263 !important" },
        }}
      >
        {title}
      </VSNTypography>

      <Stack gap={1}>
        {data?.map((el, index) => (
          <Stack direction="row" key={index}>
            <Box sx={{ height: 12, width: 12 }} mr={2} mt={0.5}>
              <StarIcon />
            </Box>
            <VSNTypography
              sx={{
                fontSize: "14px !important",
                fontWeight: 500,
                color: "#0A0A0B",
                lineHeight: "24px",
              }}
            >
              {el?.text}
            </VSNTypography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};

export const DataSummary = ({ title, data, field }) => {
  const demographicsClasses = useOTBStyle();
  const validDataCount =
    data?.filter((item) => item?.[field] !== null).length || 0;
  const totalCount = data?.length || 0;
  const diff = validDataCount - totalCount;

  return (
    <Box textAlign="center" className={demographicsClasses.reportCard}>
      <VSNTypography sx={{ fontSize: "22px", fontWeight: 600 }}>
        {title}
      </VSNTypography>

      <VSNTypography className="record" sx={{ marginTop: "4px !important" }}>
        {validDataCount}
        <span
          style={{
            color: diff < 0 ? "red" : "green",
          }}
        >
          {" "}
          ({diff})
        </span>
      </VSNTypography>
    </Box>
  );
};
